import React from 'react';
import { translate } from 'react-i18next';
import RoleActions from 'roles/components/RoleActions';

const RolRow = ({
  companyId,
  handleToggle = () => {},
  isLoading = false,
  permissions,
  t,
  role,
}) => {
  return (
    <tr>
      <td>{role.name}</td>
      <td className="text-center">{role.default ? t('common.yes') : t('common.no')}</td>
      <td className="text-center">
        <RoleActions
          companyId={companyId}
          canUpdate={permissions['acl.roles.update'] || false}
          handleToggle={handleToggle}
          isActive={role.active}
          isLoading={isLoading}
          id={role.id}
          isDefault={role.default}
          t={t}
        />
      </td>
    </tr>
  );
};

export default translate()(RolRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/components/RoleRow.js